import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopSwiggy = dynamic(() => import("../../components/software-partners/swiggy/DesktopSwiggy"), {
    loading: () => <Loading />,
});

const MobileSwiggy = dynamic(() => import("../../components/software-partners/swiggy/MobileSwiggy"), {
    loading: () => <Loading />,
});

const swiggyIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>Swiggy Orders Integrated with QueueBuster POS Software</title>
                <meta name="description" content="Swiggy + QueueBuster POS Software = Effortless Swiggy order fulfillment & efficient delivery management." />
                <link rel="canonical" href="https://queuebuster.co/pos-software-partners/swiggy" />
                <link rel="alternate" href="https://queuebuster.co/pos-software-partners/swiggy" hrefLang="en-us" />
                <meta property="og:title" content="Swiggy Orders Integrated with QueueBuster POS Software" />
                <meta property="og:description" content="Swiggy + QueueBuster POS Software = Effortless Swiggy order fulfillment & efficient delivery management." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/swiggy.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-software-partners/swiggy" />
            </Head>
            {mobileView ? <MobileSwiggy /> : <DesktopSwiggy />}
        </>
    )
}

export default swiggyIntegration